export const BackupAndRestoreOperationType = {
    'CREATE_BACKUP_IN_PROGRESS': 'CREATE_BACKUP_IN_PROGRESS',
    'RESTORE_BACKUP_IN_PROGRESS': 'RESTORE_BACKUP_IN_PROGRESS',
    'CREATE_CLOUD_BACKUP_IN_PROGRESS': 'CREATE_CLOUD_BACKUP_IN_PROGRESS',
    'RESTORE_CLOUD_BACKUP_IN_PROGRESS': 'RESTORE_CLOUD_BACKUP_IN_PROGRESS'
};
